import './bigSpinner.style.scss'
import { ReactComponent as Spinner } from '@assets/svg/spinner2.svg'
import { JSX } from 'react'
import { SpinnerLogoTbcc } from '../../clients/tbcc/assets'
import { AvailableBusiness } from '../../clients/features'
import { environment } from '../../config'
import { LogoSpinnerHeytrade } from '../../clients/heytrade/assets/svg'
import { SpinnerLogoUnicredit } from '../../clients/unicredit-pl/assets/svg'
import { SpinnerLogoBit2me } from '../../clients/bit2me/assets/svg'

export function BigSpinner(props: { children?: JSX.Element }): JSX.Element {
  const customSpinner: Record<AvailableBusiness, JSX.Element> = {
    heytrade: <LogoSpinnerHeytrade />,
    tbcc: <SpinnerLogoTbcc />,
    'unicredit-pl': <SpinnerLogoUnicredit />,
    bit2me: <SpinnerLogoBit2me />,
  }

  return (
    <div className='bigSpinner'>
      <div>
        <Spinner className='spinner path' />
        {customSpinner?.[environment?.client]}
      </div>
      {props.children}
    </div>
  )
}
